import boboloading from '@/static/json/boboloading.json';
import Lottie from 'react-lottie';
export default function Boboloading() {
  return (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: boboloading,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
          //   className: styles.animation,
        },
      }}
      height={50}
      width={50}
      isStopped={false}
      isPaused={false}
    />
  );
}
